import './tekst-beeld-onthulling.scss';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin( ScrollTrigger );

function initTekstBeeldOnthulling() {
	const roots = document.querySelectorAll( '[data-component="tekst-beeld-onthulling"]' );

	if ( ! roots.length ) {
		return;
	}

	roots.forEach( ( root ) => {
		const container = root.querySelector( '.b-tekstBeeldOnthulling__text' );

		if ( ! container ) {
			return;
		}

		let tl = null;
		let resizeTimer = null;

		// Snapshot original markup once; restoring innerHTML is cheaper than data attributes
		// and avoids attribute-length limits on very long text.
		const origHtml = container.innerHTML;

		const createAnimation = ( targetWrappers ) => {
			if ( tl ) {
				tl.kill();
			}

			tl = gsap.timeline( {
				scrollTrigger: {
					trigger: root,
					start: 'top 60%',
					end: 'center center',
					scrub: 1,
				},
			} );

			tl.to( targetWrappers, {
				width: '1.7em',
				marginLeft: '0.2em',
				marginRight: '0.2em',
				duration: 1,
				stagger: 0.2,
				ease: 'power2.inOut',
			}, 0 );

			targetWrappers.forEach( ( wrapper, i ) => {
				const img = wrapper.querySelector( 'img' );

				if ( img ) {
					tl.from( img, {
						scale: 1.3,
						duration: 1,
						ease: 'power2.inOut',
					}, i * 0.2 );
				}
			} );
		};

		const layout = () => {
			container.innerHTML = origHtml;

			const currentWrappers = Array.from( container.querySelectorAll( '.b-tekstBeeldOnthulling__wrapper' ) );

			if ( ! currentWrappers.length ) {
				return;
			}

			// Wrap each word in a span so we can measure per-word line positions.
			// Only process direct text nodes — element nodes (nowrap spans) stay as-is.
			Array.from( container.childNodes ).forEach( ( node ) => {
				if ( node.nodeType !== 3 || ! node.textContent.trim().length ) {
					return;
				}

				const hasLeadingSpace  = /^\s/.test( node.textContent );
				const hasTrailingSpace = /\s$/.test( node.textContent );
				const words            = node.textContent.split( /\s+/ ).filter( ( w ) => w.length > 0 );
				const frag             = document.createDocumentFragment();

				if ( hasLeadingSpace ) {
					frag.appendChild( document.createTextNode( ' ' ) );
				}

				words.forEach( ( w, i ) => {
					const span = document.createElement( 'span' );
					span.textContent = w;
					frag.appendChild( span );

					if ( i < words.length - 1 || hasTrailingSpace ) {
						frag.appendChild( document.createTextNode( ' ' ) );
					}
				} );

				node.replaceWith( frag );
			} );

			// Set wrappers to their final size before measuring so we detect breaks
			// at the correct positions (the positions of the fully-revealed layout).
			gsap.set( currentWrappers, { width: '1.7em', margin: '0 0.2em' } );

			const breakIndices = [];
			const visualItems  = Array.from( container.children );
			let lastTop        = -1;

			visualItems.forEach( ( item, index ) => {
				const top = item.getBoundingClientRect().top;

				if ( lastTop !== -1 && top - lastTop > 10 ) {
					breakIndices.push( index );
				}

				lastTop = top;
			} );

			// Insert <br> tags at line boundaries (reverse order to keep indices stable).
			for ( let i = breakIndices.length - 1; i >= 0; i-- ) {
				const br    = document.createElement( 'br' );
				br.className = 'b-tekstBeeldOnthulling__break';
				container.insertBefore( br, visualItems[ breakIndices[ i ] ] );
			}

			// Collapse wrappers to zero width and animate them in.
			gsap.set( currentWrappers, { width: 0, marginLeft: 0, marginRight: 0 } );
			createAnimation( currentWrappers );
		};

		// Delay layout until fonts are ready — font metrics affect line-break positions.
		document.fonts.ready.then( layout );

		const resizeHandler = () => {
			clearTimeout( resizeTimer );
			resizeTimer = setTimeout( () => {
				layout();
				ScrollTrigger.refresh();
			}, 200 );
		};

		window.addEventListener( 'resize', resizeHandler );

		root._tekstBeeldOnthullingCleanup = () => {
			window.removeEventListener( 'resize', resizeHandler );
			clearTimeout( resizeTimer );

			if ( tl ) {
				tl.kill();
			}
		};
	} );
}

if ( document.readyState === 'loading' ) {
	document.addEventListener( 'DOMContentLoaded', initTekstBeeldOnthulling );
} else {
	initTekstBeeldOnthulling();
}
